import React from "react";
import { observer, inject } from "mobx-react";
import { extendObservable } from "mobx";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import Select from "react-select-plus";
import 'react-select-plus/dist/react-select-plus.css';
import NoteSearch from "./NoteSearch";
import Relation from "./Relation";
import { CARD_RELATIONS } from "./constants";
import NoteBodyText from "./NoteBodyText";
// import {CAN_EDIT_NOTE_RELATION} from "./authorization";

@injectIntl
@inject("rootStore")
@observer
export default class Relations extends React.Component {
  constructor(props) {
    super(props);

    extendObservable(this, {
      selectedRelation: props.rootStore.noteRelationSelectOptions[0],
      searchNotes: []
    });

    this.canEdit = props.rootStore.authorizationStore.canEditNoteRelation(
      props.note
    );
  }

  render() {
    const { intl, note, rootStore } = this.props;

    return (
      <div className="note-relations-container">
        {this.canEdit && (
          <React.Fragment>
            <Select
              options={rootStore.noteRelationSelectOptions}
              value={this.selectedRelation}
              onChange={selected => (this.selectedRelation = selected)}
              clearable={false}
              style={{ marginBottom: "5px" }}
            />

            <NoteSearch
              onChange={result => (this.searchNotes = result)}
              onRef={element => {
                this.noteSearchComponent = element;
              }}
            />

            {this.renderSearchResultNotes()}
          </React.Fragment>
        )}
        {this.renderRelations()}
      </div>
    );
  }

  renderSearchResultNotes = () => {
    return (
      <div className="note-relations-search-result-container">
        {this.searchNotes.map(note => (
          <div
            key={note.id}
            className="note-container"
            onClick={this.addNoteRelation.bind(null, note)}
          >
            <NoteBodyText note={note} />
          </div>
        ))}
      </div>
    );
  };

  renderRelations() {
    const { note, intl } = this.props;

    const grouped = Object.entries(note.groupedSourceCardsRelations);

    return grouped.map(relation => {
      const relationType = relation[0];
      const relationsArray = relation[1];

      return (
        <div
          key={relationType}
          className="note-relations-relation-type-container"
        >
          {this.renderRelationGroupIcon(relationType)}
          {intl.formatMessage({ id: relationType })}:
          {relationsArray.map(r => {
            return (
              <Relation
                key={r.id}
                relation={r}
                note={note}
                disabled={!this.canEdit}
              />
            );
          })}
        </div>
      );
    });
  }

  renderRelationGroupIcon = relationType => {
    let faClass = "";

    switch (relationType) {
      case CARD_RELATIONS.RELATED_TO:
        faClass = "fa fa-long-arrow-right";
        break;
      case CARD_RELATIONS.BLOCKS:
        faClass = "fa fa-lock";
        break;
      case CARD_RELATIONS.BLOCKED_BY:
        faClass = "fa fa-lock";
        break;
      case CARD_RELATIONS.DUPLICATE:
        faClass = "fa fa-clone";
        break;
    }

    return (
      <i
        style={{ marginRight: "5px" }}
        className={faClass}
        aria-hidden="true"
      />
    );
  };

  addNoteRelation = targetNote => {
    const { note } = this.props;

    note.addNoteRelation(targetNote, this.selectedRelation.value);
    this.searchNotes = [];
    this.noteSearchComponent.clear();
  };

  // canEdit = () => {
  //     const {note, rootStore} = this.props;
  //
  //     if (this.canEditNote === undefined) {
  //         this.canEditNote = CAN_EDIT_NOTE_RELATION(rootStore, note)
  //     }
  //     return this.canEditNote;
  // }
}

Relations.propTypes = {
  note: PropTypes.object.isRequired
};
